module.exports = __webpack_public_path__ + "img/Septris-sprite-doors-closed.a80e0f14.png";